export default __webpack_public_path__ + "static/media/tax-ease-ohio-logo.fd3b5099.svg";